import type { CSSProperties, FC } from 'react';

type HeartEmptyIconProps = {
	className?: string;
	style?: CSSProperties;
};

const HeartEmptyIcon: FC<HeartEmptyIconProps> = ({ className, style }) => {
	return (
		<svg
			aria-hidden="true"
			className={className}
			fill="none"
			focusable="false"
			height="36"
			style={style}
			viewBox="0 0 42 36"
			width="42"
		>
			<title>Empty heart</title>
			<path
				d="M0.5 11.8462C0.500042 9.55729 1.19206 7.32222 2.48467 5.4362C3.77727 3.55018 5.60964 2.10194 7.73978 1.28276C9.86991 0.46358 12.1976 0.311994 14.4154 0.848024C16.6332 1.38405 18.6368 2.58248 20.1615 4.28503C20.2689 4.40024 20.3987 4.49209 20.5429 4.55489C20.6872 4.61769 20.8427 4.65009 20.9999 4.65009C21.1572 4.65009 21.3127 4.61769 21.4569 4.55489C21.6012 4.49209 21.731 4.40024 21.8384 4.28503C23.3583 2.57142 25.3624 1.36292 27.5838 0.820374C29.8052 0.277831 32.1386 0.42698 34.2734 1.24797C36.4082 2.06896 38.2432 3.52284 39.5342 5.41612C40.8251 7.3094 41.5108 9.55227 41.4999 11.8462C41.4999 16.5565 38.4249 20.0738 35.3499 23.1592L24.0913 34.0876C23.7093 34.5277 23.2384 34.8813 22.7097 35.1249C22.1811 35.3684 21.6068 35.4962 21.0251 35.4999C20.4434 35.5036 19.8676 35.3831 19.3359 35.1463C18.8042 34.9095 18.3289 34.5619 17.9413 34.1266L6.64998 23.1592C3.57499 20.0738 0.5 16.5771 0.5 11.8462Z"
				stroke="#2B7FFF"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default HeartEmptyIcon;
